export const HierarchyFilterMessages = {
	MSG_OPEN_FILTERS: 'Abrir filtros',
	MSG_APPLY: 'Aplicar',
	MSG_APPLY_TOOLTIP: 'Filtrar itens selecionados',
	MSG_SEARCH_PLACEHOLDER: 'Digite para procurar',
	MSG_LOADING: 'Carregando filtros da hierarquia...',
	MSG_NO_DATA: 'Nenhum dado encontrado',
	MSG_NO_DATA_CONFIG_LEVEL:
		'Nenhum nível encontrado para a hieraquia selecionada',
	MSG_NO_DATA_CONFIG_SUGGESTION:
		'Erro ao exibir filtros. Recarregue a página e tente novamente.',
} as const;

export type HierarchyFilterMessageType =
	(typeof HierarchyFilterMessages)[keyof typeof HierarchyFilterMessages];
